import { useSite } from "@/context/SiteContext";
import { resolveMedia } from "@/lib/media";

export const LOGO_SIZE_FACTORS = { small: 0.82, medium: 1, large: 1.4 };

export default function Logo({ size = 40, showText = true, className = "" }) {
  const site = useSite();
  const brand = site?.content?.brand || {};
  const word = brand.logo_word || brand.name || "AUREX";
  const logoUrl = brand.logo_url;
  const factor = LOGO_SIZE_FACTORS[brand.logo_size] || 1;
  const s = Math.round(size * factor);
  const wordSize = brand.logo_size === "large" ? "text-2xl" : brand.logo_size === "small" ? "text-lg" : "text-xl";

  // Custom uploaded logo (image already includes its own lettering)
  if (logoUrl) {
    return (
      <div className={`flex items-center ${className}`} data-testid="site-logo">
        <img
          src={resolveMedia(logoUrl)}
          alt={word}
          style={{ height: s * 1.25 }}
          className="w-auto object-contain"
        />
      </div>
    );
  }

  // Built-in AUREX mark — angular hollow "X" ribbon with copper→rose gradient
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="site-logo">
      <svg
        width={s}
        height={s}
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label={word}
      >
        <defs>
          <linearGradient id="aurexX" x1="50" y1="14" x2="50" y2="88" gradientUnits="userSpaceOnUse">
            <stop stopColor="var(--aurex-accent-soft)" />
            <stop offset="0.55" stopColor="var(--aurex-accent)" />
            <stop offset="1" stopColor="var(--aurex-accent-2)" />
          </linearGradient>
        </defs>

        {/* badge ring */}
        <circle cx="50" cy="50" r="46.5" stroke="var(--aurex-muted)" strokeOpacity="0.3" strokeWidth="1.3" fill="none" />

        {/* angular hollow X ribbons */}
        <g
          stroke="url(#aurexX)"
          strokeWidth="5"
          strokeLinejoin="miter"
          strokeLinecap="butt"
          fill="none"
        >
          <path d="M23 22 L38 22 L52 44 L78 78 L63 78 L49 56 Z" />
          <path d="M77 22 L62 22 L48 44 L22 78 L37 78 L51 56 Z" />
        </g>
      </svg>
      {showText && (
        <span
          className={`font-display ${wordSize} font-extrabold tracking-[0.3em]`}
          style={{ color: "var(--aurex-text)" }}
        >
          {word}
        </span>
      )}
    </div>
  );
}
